// mock for development
export default function mockProjectOptions() {
  const config = {
    network: {
      baseUrl:
        "https://9b7ef0f383974367ade0376c2fd0cabc.lb.akinoncloud.com/live-commerce/api/v1",
      basketUrl: "https://www.marksandspencer.com.tr/baskets/basket/",
      crsfToken:
        "6rrQrF8dTbTHq2qU1X48dqq00pTduLonor5JtqQ7T8vKTwCc1XzORfXZXMNaE70t",
      eventId: "19",
      widgetUrl: "https://lcdemo.vercel.app",
      monitoringEnvKey: "j713jgs7j1q2nnsh8mf0ufdc3",
      pathname: "/live-commerce-test",
    },
    options: {
      videoType: "stream",
      brand: "https://demo.akinon.net/",
      isTestStream: "0",
      streamTitle: "Test Video Başlığı 1",
      productListTitle: "Yayındaki Diğer Ürünler Demo",
      thumbnailOptions: {
        active: true,
        "product-live-comm": {
          height: 450,
          width: 450,
        },
        "product-live-comm-highlight": {
          height: 450,
          width: 450,
        },
      },
      variantKeys: {
        size: "beden",
        color: "renk",
      },
      showVideo: false,
      showVideoUntil: "",
      showProductsBeforeOnAir: {
        isEnabled: false,
        buyDisabled: true,
        date: "2022-09-08T12:00:00.003Z",
      },
    },
    style: {
      isCenter: true,
      posterPc: "924c88e9-8ef4-4cf5-ba54-e6913b8072fa",
      posterMobile: "8f63ac64-5df3-4f31-bab3-305f07dfff10",
      videoBackground:
        "https://media.discordapp.net/attachments/959514754290954265/968447356326535178/white-bedding-sheets-white-fabric-wrinkle-texture-background-soft-focus_1962-255.webp?width=1014&height=676",
      highlightProductBorder:
        "https://media.discordapp.net/attachments/959514754290954265/968440662590640148/HighlightBorderBg.png",
      hideProductList: false,
      product: {
        currency: "{xxx,xxx,xxx,xxx.xx}",
        currencyPattern: "",
        showDiscount: true,
        showCouponCode: true,
        couponText: "LIVECOUPON",
        productImage: 0,
        buttonColor: "#000",
      },
      modal: {
        afterModal: true,
      },
    },
    template_name: "flatpages/index_flat.html",
  };

  return {
    ...config,
  };
}
